import chosen from 'chosen-js';
import queryString from 'query-string';

const $ = window.jQuery;

$( 'select#hero-product-category, select#hero-product-sort-by' ).chosen( {
	disable_search: true,
} );

$( 'select#hero-product-category' ).change( function() {

	window.location = $( this ).val();

} )

$( 'select#hero-product-sort-by' ).change( function() {

	const sortby = $( 'select#hero-product-sort-by option:selected' ).data( 'sortby' );
	const sort = $( 'select#hero-product-sort-by option:selected' ).data( 'sort' );

	const parsed = queryString.parse( location.search );
	parsed.sortby = sortby;
	parsed.sort = sort;

	if ( ! sortby ) {
		delete parsed.sortby;
	}

	if ( ! sort ) {
		delete parsed.sort;
	}

	window.location.search = queryString.stringify( parsed );

} );
